import type { GuideStatus } from '@/types/crm'
import { formatDate } from '@/shared/util/dates'

/**
 * Per-guide Skida PRO sign-in status.
 *
 * Two columns rather than four: guide identity stacks name over email, status
 * stacks the pill over the first-login date. At sidebar-constrained widths the
 * four-column version truncated every email to uselessness.
 *
 * Every value is written by `crmFirstLoginWatcher` from the product's own
 * collections — read-only here, hence the "monitored automatically" note.
 */
export function GuideStatusTable({ guides }: { guides: GuideStatus[] }) {
  return (
    <section className="card">
      <div className="card-label">
        Skida PRO status per guide <span className="guides__hint">(monitored automatically)</span>
      </div>

      <div className="guides__head">
        <div>Guide</div>
        <div>Status</div>
      </div>

      {guides.map((g) => (
        <div className="guides__row" key={g.email || g.name}>
          <div className="guides__who">
            <div className="guides__name">{g.name}</div>
            <div className="guides__email">{g.email}</div>
          </div>
          <div>
            <span className={`pill ${g.signedIn ? 'pill--success' : 'pill--neutral'}`}>
              {g.signedIn ? 'Signed in' : 'Not signed in'}
            </span>
            {g.signedIn && <div className="guides__since">since {formatDate(g.firstLoginAt)}</div>}
          </div>
        </div>
      ))}

      {guides.length === 0 && (
        <div className="empty-note guides__empty">No guides signed in yet.</div>
      )}
    </section>
  )
}
